var Region = /** @class */ (function () {
    function Region(props) {
        Object.assign(this, props);
    }
    return Region;
}());
export default Region;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Regions/Region.ts
// module id = 748
// module chunks = 0